var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-base-operation-box"},[_c('div',{staticClass:"c-base-operation-box__title"},[_c('i',{staticClass:"icon"},[_vm._t("icon-title")],2),_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default"),(!_vm.isFooter)?_c('div',{staticClass:"c-base-operation-box__footer"},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }